
import { supabase } from '@/integrations/supabase/client';

interface NotificationData {
  userId: string;
  title: string;
  body: string;
  type: 'new_match' | 'new_message' | 'profile_view' | 'event_reminder' | 'system_notification';
  data?: Record<string, any>;
}

class NotificationService {
  async sendNotification(notificationData: NotificationData) {
    try {
      console.log('Sending notification:', notificationData);
      
      const { data, error } = await supabase.functions.invoke('send-push-notification', {
        body: notificationData
      });

      if (error) {
        console.error('Error sending notification:', error);
        return false;
      }

      console.log('Notification sent successfully:', data);
      return true;
    } catch (error) {
      console.error('Failed to send notification:', error);
      return false;
    }
  }

  async sendMatchNotification(userId: string, matchName: string) {
    return this.sendNotification({
      userId,
      title: '🎉 New Match!',
      body: `You and ${matchName} liked each other! Start chatting now.`,
      type: 'new_match',
      data: { matchName }
    });
  }

  async sendMessageNotification(userId: string, senderName: string, matchId?: string) {
    return this.sendNotification({
      userId,
      title: '💬 New Message',
      body: `${senderName} sent you a message`,
      type: 'new_message',
      data: { senderName, matchId }
    });
  }

  async sendProfileViewNotification(userId: string, viewerName: string) {
    return this.sendNotification({
      userId,
      title: '👀 Profile View',
      body: `${viewerName} viewed your profile`,
      type: 'profile_view',
      data: { viewerName }
    });
  }

  async sendEventReminderNotification(userId: string, eventTitle: string, eventId: string) {
    return this.sendNotification({
      userId,
      title: '📅 Event Reminder',
      body: `Don't forget: ${eventTitle} is starting soon!`,
      type: 'event_reminder',
      data: { eventTitle, eventId }
    });
  }

  async sendSystemNotification(userId: string, title: string, body: string, data?: Record<string, any>) {
    return this.sendNotification({
      userId,
      title,
      body,
      type: 'system_notification',
      data
    });
  }
}

export const notificationService = new NotificationService();
